export default __webpack_public_path__ + "static/media/three.0ec65dde.jpeg";